import ReactGA from "react-ga";

const options = {};

const trackPage = page => {
  ReactGA.set({
    page,
    ...options
  });
  ReactGA.pageview(page);
};

let currentPage = "";

export const googleAnalytics = store => next => action => {
  let state = store.getState();
  let user = state && state.app && state.app.userState;
  ReactGA.set({ userId: user && user.id });

  if (action.type === "@@router/LOCATION_CHANGE") {
    const nextPage = `${action.payload.pathname}${action.payload.search}`;

    if (currentPage !== nextPage) {
      currentPage = nextPage;
      trackPage(nextPage);
    }
  }

  /*ReactGA.event({
    category: "User",
    action: "Created account"
  });*/

  return next(action);
};



// WEBPACK FOOTER //
// ./src/reactGAMiddleware.js